module.exports = __webpack_public_path__ + "static/media/hea_har_gas_dus.4618add5.png";